import React, { useState } from "react";
import { Box, Typography, Button, Stack, TextField, Divider } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ShippingEstimate from "./ShippingEstimate";

const CartSummary = ({ total = 0, shipping = 0, tax = 0, cartItems, currency = "$" }) => {
  const [isShippingExpanded, setIsShippingExpanded] = useState(false);

  const [totalPrice, setTotalPrice] = useState(total + shipping + tax);

  const handleTotalCalculated = (calculatedTotal) => {
    setTotalPrice(calculatedTotal); // Update total in parent
    // Navigate back to the previous page if needed
    // For example: history.push("/previous-page");
    console.log()
  };
  const handleShippingExpand = () => {
    setIsShippingExpanded(!isShippingExpanded);
  };

  const finalTotal = total + shipping + tax;

  return (
    <Box flex >
      <Stack
        sx={{
          mt: 3,
          width: "100%",
          // bgcolor: "#f8f8f8",
          p: 2,
          borderRadius: 1,
        }}
        alignItems={"flex-start"}
        spacing={2}
      >
        {/* Subtotal Display */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography variant="body1" sx={{ fontFamily: "'Nunito Sans', sans-serif", }}>
            Subtotal:
          </Typography>
          <Typography variant="body1" sx={{ fontFamily: "'Nunito Sans', sans-serif", }}>
            {currency} {total.toFixed(2)}
          </Typography>
        </Box>

        {shipping > 0 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography variant="body1" sx={{ fontFamily: "'Nunito Sans', sans-serif", }}>
              Shipping:
            </Typography>
            <Typography variant="body1" sx={{ fontFamily: "'Nunito Sans', sans-serif", }}>
              {currency} {shipping.toFixed(2)}
            </Typography>
          </Box>
        )}

        {tax > 0 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography variant="body1" sx={{ fontFamily: "'Nunito Sans', sans-serif", }}>
              Tax:
            </Typography>
            <Typography variant="body1" sx={{ fontFamily: "'Nunito Sans', sans-serif", }}>
              {currency} {tax.toFixed(2)}
            </Typography>
          </Box>
        )}

        <Button
          variant="contained"
          fullWidth
          endIcon={<ExpandMoreIcon />}
          sx={{
            color: "#fff",
          }}
          onClick={handleShippingExpand}
        >
          Get Shipping Estimates
        </Button>
        <ShippingEstimate expanded={isShippingExpanded} currencyforShipEsti={currency} price={total} onTotalCalculated={handleTotalCalculated} />


        <Typography variant="body2" color="text.secondary">
          Shipping, taxes, and discounts will be calculated at checkout.
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",

          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold", fontFamily: "'Nunito Sans', sans-serif", }}>
            Total:
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: "bold", fontFamily: "'Nunito Sans', sans-serif", }}>
            {currency} {finalTotal.toFixed(2)}
          </Typography>
        </Box>






      </Stack>

    </Box>
  );
};

export default CartSummary;
